import gql from 'graphql-tag'

export const DELETE_FAVORITE_LIST = gql`
  mutation DeleteFavoriteList($id: Int!) {
    deleteFavoriteList(id: $id) {
      id
    }
  }
`
